import React from 'react';
import Layout from './components/base.jsx';
import Hero from './components/Hero';
import Features from './components/Features';
import StatsSection from './components/StatsSection';
import Carrousel from './components/carrousel';
import Partners from './components/Partners';
import ContactForm from './components/ContactForm';
import Experts from './components/Experts';

import './styles/App.css';



function App() {
  return (
    <Layout>
      <Hero />
      <Carrousel/>
      
      <StatsSection />
      
      <Features />
      <Partners />
      <Experts />

      <ContactForm /> 
    </Layout>
  );
}

export default App;
